module.exports = __webpack_public_path__ + "static/img/blanco25_logo_zurqui.b60d3e73.png";